import { PaymentRequestDetailType } from 'models/payment-tracker.model';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';

export type PaymentTrackerContextType = {
  paymentItemToEdit: PaymentRequestDetailType | null;
  setPaymentItemToEdit: Dispatch<SetStateAction<PaymentRequestDetailType | null>>;
};

export const PaymentTrackerContext = createContext({} as PaymentTrackerContextType);

const usePaymentTrackerContext = () => {
  const context = useContext(PaymentTrackerContext);
  return context;
};

export default usePaymentTrackerContext;
